export default __webpack_public_path__ + "content/media/7.f73b2ec9.jpg";